import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import { useDispatch } from 'react-redux';
import { useRunOnceWhenTruthy } from '../common/useRunOnceWhenTruthy';
import { DocumentationPageType } from './types';
import {
  DEFAULT_OBJECTS_TAB_ID,
  setActivePageTab,
  setDocumentationPageType,
} from '../../reducers/documentation/documentationPageReducer';
import { useSetQueryParamsOnMount } from '../../navigation-utils/useSetQueryParamsOnMount';
import useQueryParams from '../../navigation-utils/useQueryParams';

export const useHandleDeepLinkParams = ({
  documentationPageType,
  isExpandedMode,
  activePageTab,
  activeObjectName,
}: {
  documentationPageType: DocumentationPageType;
  isExpandedMode: boolean | undefined;
  activePageTab?: string;
  activeObjectName?: ObjectTypeName;
}) => {
  const dispatch = useDispatch();
  const queryParams = useQueryParams();

  useRunOnceWhenTruthy(() => {
    const documentationPageTypeParam = queryParams.get(DeepLinkSearchParams.documentationPageType)
      ? (queryParams.get(DeepLinkSearchParams.documentationPageType) as DocumentationPageType)
      : undefined;
    const activePageTabParam = queryParams.get(DeepLinkSearchParams.activeDocumentationPageType);

    let newPageType: DocumentationPageType;
    let newActiveTab: string;

    switch (activePageTab) {
      case DEFAULT_OBJECTS_TAB_ID:
        newPageType = documentationPageTypeParam || DocumentationPageType.metadataTypes;
        newActiveTab = activePageTabParam || DEFAULT_OBJECTS_TAB_ID;
        break;

      case 'users':
        newPageType = DocumentationPageType.tagsAndUsers;
        newActiveTab = 'users';
        break;

      case 'tags':
        newPageType = DocumentationPageType.tagsAndUsers;
        newActiveTab = 'tags';
        break;

      default:
        newPageType = documentationPageTypeParam ?? DocumentationPageType.metadataTypes;
        newActiveTab = activePageTabParam ?? DEFAULT_OBJECTS_TAB_ID;
        break;
    }

    dispatch(
      setDocumentationPageType({
        documentationPageType: newPageType,
      }),
    );
    dispatch(setActivePageTab({ tabId: newActiveTab }));
  }, Boolean(documentationPageType));

  useSetQueryParamsOnMount({
    [DeepLinkSearchParams.isExpandedMode]: isExpandedMode ? 'true' : 'false',
    [DeepLinkSearchParams.documentationPageType]: documentationPageType,
    [DeepLinkSearchParams.activeDocumentationPageType]: activePageTab,
    [DeepLinkSearchParams.objectName]: activeObjectName?.objectType,
  });
};
